import { useSelector } from 'react-redux'
import { RootState } from 'app/store'

const useSelectorWithParams = <P extends Record<string, any> = Record<string, any>, D = unknown>(
  selector: (state: RootState, params: P) => D,
  params: P,
) => useSelector<RootState, D>((state) => selector(state, params))

export default useSelectorWithParams
